import React from 'react'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'

import { Box, Button, Link, Typography } from '@mui/material'
import { ChevronLeft } from '@mui/icons-material'
import TwoFactorDigitsComponent from '@/views/components/two-factor-digits/index.component'

import { TwoFactorStatus } from '@/enums/two-factor-status.enum'

type Props = {
  twoFactorStatus: TwoFactorStatus
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  setTwoFactorStatus: (status: TwoFactorStatus) => void
}

const TwoFactorComponent = ({ twoFactorStatus, setTwoFactorStatus }: Props) => {
  const { t } = useTranslation()

  const [fieldAuthenticationCode] = useField('twoFactorCode')

  return (
    <Box>
      <Button
        component={Link}
        startIcon={<ChevronLeft />}
        onClick={() => {
          setTwoFactorStatus(TwoFactorStatus.INITIAL)
        }}
        className="white"
        sx={{ pl: 0, justifyContent: 'left' }}
      >
        {t('labels.back')}
      </Button>
      <Typography component="h2" variant="h5">
        {t('twoFactor.twoFactorTitle')}
      </Typography>
      <Typography variant="body2" paragraph>
        {t('twoFactor.twoFactorInstructions')}
      </Typography>
      <TwoFactorDigitsComponent twoFactorStatus={twoFactorStatus} />
      <Box mt={2} width="100%">
        <Button
          variant="contained"
          color="primary"
          fullWidth
          type="submit"
          disabled={fieldAuthenticationCode.value.length < 6}
        >
          {fieldAuthenticationCode.value.length < 6
            ? `${6 - fieldAuthenticationCode.value.length} ${t(
                'twoFactor.twoFactorDigits',
              )}`
            : t('twoFactor.twoFactorVerify')}
        </Button>
      </Box>
    </Box>
  )
}

export default TwoFactorComponent
